export function numberWithCommas(
  num: number | undefined | null
): string | undefined | null {
  if (num == null) {
    return num;
  }
  return num.toLocaleString("en-US");
}
